export const INIT_VIDEO = 'BEAMLY/CCX/INIT_VIDEO';
export const SET_VIDEO_PLAY = 'BEAMLY/CCX/SET_VIDEO_PLAY';
export const SET_TOGGLE_VIDEO_PLAY_PAUSE = 'BEAMLY/CCX/SET_TOGGLE_VIDEO_PLAY_PAUSE';
export const SET_VIDEO_VOLUME = 'BEAMLY/CCX/SET_VIDEO_VOLUME';
export const SET_TOGGLE_VIDEO_MUTED = 'BEAMLY/CCX/SET_TOGGLE_VIDEO_MUTED';
export const SET_VIDEO_PROGRESS = 'BEAMLY/CCX/SET_VIDEO_PROGRESS';
export const SET_VIDEO_DURATION = 'BEAMLY/CCX/SET_VIDEO_DURATION';
export const SET_VIDEO_SEEKING = 'BEAMLY/CCX/SET_VIDEO_SEEKING';
export const SET_VIDEO_STOPPED = 'BEAMLY/CCX/SET_VIDEO_STOPPED';
export const SET_VIDEO_MILESTONE = 'BEAMLY/CCX/SET_VIDEO_MILESTONE';
export const RESET_VIDEO_MILESTONE = 'BEAMLY/CCX/RESET_VIDEO_MILESTONE';
export const SET_MEDIA_PLAY = 'BEAMLY/CCX/SET_MEDIA_PLAY';
